export function commonFunc() {
  // フェードイン
  const scrollElements = document.querySelectorAll(".js-fadeIn");
  // 左から来るフェードイン
  const scrollElementsLeft = document.querySelectorAll(".js-fadeInLeft");
  // 右から来るフェードイン
  const scrollElementsRight = document.querySelectorAll(".js-fadeInRight");

  const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop <=
      (window.innerHeight - '100' || document.documentElement.clientHeight) / dividend
    );
  };

  const elementOutofView = (el) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop > (window.innerHeight || document.documentElement.clientHeight)
    );
  };

  const displayScrollElement = (element) => {
    element.classList.add("scrolled");
  };

  const hideScrollElement = (element) => {
    element.classList.remove("scrolled");
  };

  const handleScrollAnimation = () => {
    // 通常のフェードイン
    scrollElements.forEach((el) => {
      if (elementInView(el, 1)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el)
      }
    });
    
    // 左から来るフェードイン
    scrollElementsLeft.forEach((el) => {
      if (elementInView(el, 1)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el)
      }
    });
    
    // 右から来るフェードイン
    scrollElementsRight.forEach((el) => {
      if (elementInView(el, 1)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el)
      }
    });
  }

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });

  window.addEventListener("load", () => {
    handleScrollAnimation();
  });
}